import {
  DEFAULT_FRAUD_AND_DISPUTES_FLAG_VALUE,
  SHOW_FRAUD_DISPUTES,
} from '../../../constants/LaunchDarklyConstants';
import { getLaunchDarklyFlag } from '../../../utils/LaunchDarklyUtils';

class FraudAndDisputesLDWrapper {
  async showFraudAndDisputesJourney() {
    const flagValue = await getLaunchDarklyFlag(
      SHOW_FRAUD_DISPUTES,
      DEFAULT_FRAUD_AND_DISPUTES_FLAG_VALUE
    );
    return flagValue;
  }
}

export default new FraudAndDisputesLDWrapper();
